<template>
  <div>
    <Header/>
    <Scroll/>
    <div>
      <div class="mall_pageTopWrap">
        <p class="mall_pageTopTit">Company</p>
      </div>
      <div class="page_companyWrap">
          <div class="page_companyWrapTit">ABOUT</div>
          <div class="page_companyBox">
            <div class="page_companyInfo_img page_companyBlockMobNonePc">
              <img src="../../../assets/images/etc/img_nfuMainNew.jpg" alt="회사소개 모바일">
            </div>
            <div class="page_companyInfo_txt">
              <p class="page_companyInfo_txtTit">Necessary For You</p>
              <p>
                1994년 설립된 엔포유는 'One-Stop Total Design Service'을 통해 주거공간 및 다양한 상업공간에
                프리미엄 라이프스타일을 제안합니다.
              </p>
              <p>
                3개의 층으로 구성된 엔포유는 각 층 공간마다 서로 다른 켄셉과
                브랜드관으로 구성되어 있으며, 모더니즘 디자인을 대표하는 건축가의 디자인부터
                컨템포러리 디자인까지 전통과 가치, 실용성을 간직한 다양한 리빙 브랜드를 한곳에서 만날 수 있는
                하이엔드 리빙 편집숍입니다.
              </p>
              <p>
                엔포유는 공간을 인테리어하는 가구, 조명, 주방, 패브릭, 커튼, 러그, 아웃도어 가구 등을
                하나로 연결해 차별화된 'One-Stop Total Design Service'를 제공하여 공간의 컨셉 제안에서부터
                제품 컬렉션 및 현장 설치 등 각 분야 전문가의 컨설팅 서비스로 조화롭고 개성 있는 솔루션을 제안해 드립니다.
                또한, 갤러리와 협업을 통해 작품 전시 및 문화 강좌를 진행하여 소통과 교류의 문화공간을 만들어 한층 더 품격있는
                라이프 스타일을 제공합니다.
              </p>
            </div>
            <div class="page_companyInfo_img page_companyNoneMobBlockPc">
              <img src="../../../assets/images/etc/img_nfuMainPcNew2.jpeg" alt="회사소개 pc">
            </div>
          </div>

          <div class="page_companyWrapTit">CONTACT</div>
          <div class="page_companyBox">
            <div class="page_companyInfo_txt">
              <p>
                (48060) 부산광역시 해운대구 센텀2로 16 엔포유<br/>
                월-일 10:30 - 19:00 (연중무휴)<br/>
                051-743-6147<br/>
                nforuhome@gmail.com
              </p>

              <p>
                지하철 : 2호선 센텀시티역 11번 출구 도보 5분<br/>
                자가용 : 엔포유 건물 앞 지상 주차장 이용 가능
              </p>
            </div>

            <div id="kakao-map" class="page_companyInfo_map"></div>
          </div>

          <div class="page_companyInfo_btn">
            <a href="https://kko.kakao.com/osjyvTLdSy" target="_blank">
              지도 자세히보기
            </a>
          </div>
        </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'

export default {
  name: 'Company',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll: Scroll
  },
  methods: {
    initKakaoMap () {
      const mapContainer = document.getElementById('kakao-map')
      const mapOption = {
        // eslint-disable-next-line no-undef
        center: new kakao.maps.LatLng(35.167492, 129.131767),
        level: 3
      }

      // eslint-disable-next-line no-undef
      const map = new kakao.maps.Map(mapContainer, mapOption)

      // eslint-disable-next-line no-undef
      const markerPosition = new kakao.maps.LatLng(35.167492, 129.131767)

      // eslint-disable-next-line no-undef
      const marker = new kakao.maps.Marker({
        position: markerPosition
      })

      marker.setMap(map)

      // 인포윈도우 내용 - 맵 위치 표시
      const content = `
        <div style="
          background: white;
          border: 1px solid #ccc;
          border-radius: 5px;
          box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
          padding: 10px;
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          line-height: 1.5;
          width: auto;
        ">
          엔포유
        </div>
        <img 
          style = "
            margin-top:35px;
            width:10px;
            height:10px;
          "
          src="https://t1.daumcdn.net/localimg/localimages/07/2018/pc/map/marker_map01.png"
        >
      `

      // eslint-disable-next-line no-undef
      const customOverlay = new kakao.maps.CustomOverlay({
        position: markerPosition,
        content: content,
        yAnchor: 1
      })

      customOverlay.setMap(map)
    }
  },
  mounted () {
    this.initKakaoMap()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Company/Company.vue